<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { watch } from 'vue'
import { AuthActionTypes, useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth'

// Route & Router
const route = useRoute()
const router = useRouter()

// Store
const AuthStore = useAuthStore()

// Nếu đã login thì chuyển về /
watch(
  () => AuthStore.action_type,
  (newVal) => {
    if (newVal === AuthActionTypes.LOGINED) {
      const redirectTo = route.query.redirect?.toString() || '/'
      router.push(redirectTo)
    }
  },
  { immediate: true }
)
</script>

<template>
  <component
    v-if="route.meta.component"
    :is="route.meta.component"
  />
  <div v-else>
    <!-- fallback UI -->
    <p>Đang tải trang...</p>
  </div>
</template>

<style scoped>
/* tuỳ chọn thêm CSS */
</style>
